module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "problem-answer"
  }, [_c('navbar', {
    attrs: {
      "transparent": _vm.isTransparent,
      "activeTo": "Services"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "problem-solve"
  }, [_c('h3', [_vm._v("Q: " + _vm._s(_vm.problem_answer.title))]), _vm._v(" "), _c('div', {
    staticClass: "answer-content"
  }, [_vm._v("\n            A: "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.problem_answer.content)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "like_problem"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('consultation_Questions')))]), _vm._v(" "), _vm._l((_vm.likeProblem), function(item, index) {
    return _c('a', {
      key: index
    }, [_c('router-link', {
      staticClass: "like_problem_title",
      attrs: {
        "to": {
          name: 'problemContent',
          params: {
            id: item.id
          }
        }
      }
    }, [_vm._v("\n                " + _vm._s(index + 1) + ". " + _vm._s(item.title) + "\n            ")])], 1)
  })], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-54cfd4b0","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Services/ProblemContent.vue
// module id = 813
// module chunks = 0